export const styles = {
  modalContainer: {
    padding: 20,
  },
  attachmentsContainer: {
    margin: '10px 0px',
  },
  fileIconContainer: {
    marginBottom: '10px',
  },
  title: { 
    fontSize: '16px',
  },
  text: {
    margin: 0, 
    padding: 0,
  },
  listItemContainer: {
    backgroundColor: '#f7f7f7',
    borderRadius: '20px',
    padding: '6px 25px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  verticalAlignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    color: '#1BBFBB',
    fontSize: '24px',
  },
  iconMuted: {
    color: '#aaa',
    fontSize: '24px',
  },
  marginRight: {
    marginRight: '12px',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
};
